import PropTypes from 'prop-types';
import React from 'react';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';

function ProductHeaderSection({ product, theme, t }) {
	if (!product.Item_Description && !product.Design_Number) {
		return null;
	}

	return (
		<Grid item>
			{product.Item_Description && (
				<Grid item xs={12}>
					<Grid container spacing={2}>
						<Grid item xs={12}>
							<Typography
								variant="h2"
								aria-label={product.Item_Description}
								role="paragraph"
								style={{
									lineHeight: theme.palette.lineHeight.Lg,
								}}
							>
								{product.Item_Description}
							</Typography>
						</Grid>
					</Grid>
				</Grid>
			)}

			{product.Design_Number && (
				<Grid item xs={12} mt={-1.75}>
					<Typography
						variant="heading7"
						style={{ fontSize: theme.palette.textSize.sizeLg }}
						aria-label={product.Design_Number}
						role="paragraph"
					>
						{t('sku_number')}: {product.Design_Number}
					</Typography>
				</Grid>
			)}
		</Grid>
	);
}

ProductHeaderSection.propTypes = {
	product: PropTypes.shape({
		Design_Number: PropTypes.any,
		Item_Description: PropTypes.any,
	}).isRequired,
	t: PropTypes.func.isRequired,
	theme: PropTypes.object.isRequired,
};

export default ProductHeaderSection;
